import { memo, useCallback, useState } from 'react';

import { type Form } from '@air/api/types';

import { PermissionToggleInfo } from '~/components/SharePrivateContentModal/shared/PermissionToggleInfo';
import { SharePrivateContentPermissionToggle } from '~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle';
import { useUpdateForm } from '~/swr-hooks/forms/useUpdateForm';

type ContentCollectionCreateSubmissionBoardToggleProps = {
  form: Form;
};

export const ContentCollectionCreateSubmissionBoardToggle = memo(
  ({ form }: ContentCollectionCreateSubmissionBoardToggleProps) => {
    const { updateForm } = useUpdateForm();
    const [isLoading, setIsLoading] = useState(false);

    const onCheckedChange = useCallback(
      async (checked: boolean) => {
        setIsLoading(true);
        await updateForm({
          ...form,
          createSubmissionBoard: checked,
        });
        setIsLoading(false);
      },
      [form, updateForm],
    );

    return (
      <SharePrivateContentPermissionToggle
        label="Organize submissions into sub-boards"
        id="createSubmissionBoard"
        isLoading={isLoading}
        checked={!!form.createSubmissionBoard}
        onCheckedChange={onCheckedChange}
      >
        <PermissionToggleInfo text="A new sub-board will be created for each upload session." />
      </SharePrivateContentPermissionToggle>
    );
  },
);

ContentCollectionCreateSubmissionBoardToggle.displayName = 'ContentCollectionCreateSubmissionBoardToggle';
